export class AuthenticationCredentials {
    username?: any = '';
    phone?: any = '';
    password: string = '';
    app: string = 'PATIENT_PORTAL';

}


